// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-create-field__input{margin-top:2rem}.comment-create-field__avatar>i{font-size:55px!important}", ""]);
// Exports
module.exports = exports;
